const BROWSER_PATTERNS: [RegExp, string][] = [
  [/Edg(?:e|A)?\//, 'Edge'],
  [/OPR\/|Opera\//, 'Opera'],
  [/SamsungBrowser\//, 'Samsung Browser'],
  [/UCBrowser\//, 'UC Browser'],
  [/Firefox\//, 'Firefox'],
  [/CriOS\//, 'Chrome'],
  [/FxiOS\//, 'Firefox'],
  [/Chrome\//, 'Chrome'],
  [/Safari\//, 'Safari'],
];

const OS_PATTERNS: [RegExp, string][] = [
  [/iPhone/, 'iPhone'],
  [/iPad/, 'iPad'],
  [/Windows/, 'Windows'],
  [/Macintosh|Mac OS X/, 'Mac'],
  [/Android/, 'Android'],
  [/CrOS/, 'Chrome OS'],
  [/Linux/, 'Linux'],
];

function detectBrowser(ua: string): string | undefined {
  for (const [pattern, name] of BROWSER_PATTERNS) {
    if (pattern.test(ua)) {
      return name;
    }
  }
  return undefined;
}

function detectOS(ua: string): string | undefined {
  for (const [pattern, name] of OS_PATTERNS) {
    if (pattern.test(ua)) {
      return name;
    }
  }
  return undefined;
}

export function parseDeviceName(name: string | undefined | null): string {
  if (!name) {
    return '';
  }

  if (!name.includes('/') && !name.startsWith('Mozilla')) {
    return name;
  }

  const browser = detectBrowser(name);
  const os = detectOS(name);

  if (browser && os) {
    return `${browser} on ${os}`;
  }
  if (browser) {
    return browser;
  }
  if (os) {
    return os;
  }

  return name;
}
